import React, { useState } from 'react'
import './query.scss'
import QueryEditor from './QueryEditor'
import { Button, Checkbox, Select, Space } from 'antd'
import { actions } from '../../../store/reducers/assignment.reducer'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { PATTERN_TYPES } from '../../../constants/pattern-types'
import PatternIcon from '../PatternIcon'

const Query = ({
    assignment,
    query,
    drawer,
    regroup,
    setQuery,
    setIdOfPatternToChange,
    setQueryToCompare,
    setRegroup,
    runQuery,
    compareQueries,
}) => {
    const { token, layerId } = useParams()

    const [isWaitingForRunQuery, setIsWaitingForRunQuery] = useState(false)
    const [isWaitingForCompareQueries, setIsWaitingForCompareQueries] = useState(false)

    const compareQueryOptions = assignment.patterns.reduce((result, pattern) => {
        if (pattern.type === PATTERN_TYPES.QUERY.value && pattern.query)
            result.push({
                label: (
                    <Space size={8} title={pattern.query}>
                        <PatternIcon id={pattern.motif_id} type={pattern.type} colorId={pattern.color_id} />
                        {pattern.motif_caption}
                    </Space>
                ),
                value: pattern.motif_id,
            })
        return result
    }, [])

    const handleRunQueryClick = async () => {
        setIsWaitingForRunQuery(true)
        await runQuery(token, layerId)
        setIsWaitingForRunQuery(false)
    }

    const handleCompareQueriesClick = async () => {
        setIsWaitingForCompareQueries(true)
        await compareQueries(token, layerId)
        setIsWaitingForCompareQueries(false)
    }

    const handleRegroupChange = () => {
        setRegroup()
    }

    const handleQueryToCompareChange = (_, option) => {
        setQueryToCompare(option)
    }

    const handleStopEditingPatternClick = () => {
        setIdOfPatternToChange(null)
        setQuery('')
    }

    return (
        <div className='query__container' id='query-container'>
            <div className='mb-8 d-flex-space-between'>
                <Space size={8}>
                    <Button
                        size='small'
                        type='default'
                        onClick={handleCompareQueriesClick}
                        loading={isWaitingForCompareQueries}
                    >
                        Compare query
                    </Button>
                    <Select
                        size='small'
                        position='topRight'
                        style={{ minWidth: 180 }}
                        popupMatchSelectWidth={false}
                        onChange={handleQueryToCompareChange}
                        getPopupContainer={() => document.getElementById('query-container')}
                        options={compareQueryOptions}
                        placeholder='Select query to compare to'
                        aria-label='Select query to compare to'
                        showSearch
                        optionFilterProp='label'
                    />
                </Space>
                {drawer.idOfPatternToChange !== null && (
                    <Button size='small' type='default' onClick={handleStopEditingPatternClick}>
                        Stop editing pattern {drawer.idOfPatternToChange}
                    </Button>
                )}
            </div>
            <QueryEditor value={query} onChange={setQuery} />
            <div className='d-flex-space-between'>
                <Space size={8}>
                    <Button size='small' type='primary' onClick={handleRunQueryClick} loading={isWaitingForRunQuery}>
                        Run query
                    </Button>
                    <Checkbox checked={regroup} onChange={handleRegroupChange}>
                        Regroup
                    </Checkbox>
                </Space>
            </div>
        </div>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
        drawer: assignment.drawer,
        query: assignment.query,
        regroup: assignment.regroup,
    }
}

const mapDispatch = dispatch => {
    return {
        setQuery(value) {
            dispatch(actions.setQuery(value))
        },
        setIdOfPatternToChange(value) {
            dispatch(actions.setIdOfPatternToChange(value))
        },
        setQueryToCompare(value) {
            dispatch(actions.setQueryToCompare(value))
        },
        runQuery(token, layerId) {
            return dispatch(actions.runQuery(token, layerId))
        },
        setRegroup() {
            dispatch(actions.setRegroup())
        },
        compareQueries(token, layerId) {
            return dispatch(actions.compareQueries(token, layerId))
        },
    }
}

export default connect(mapState, mapDispatch)(Query)
